import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';

import { auth } from '@/lib/firebase-init';
import { useToastContext } from '@/components/toast/toast-context';

import { GoogleButton } from '../../components/google-button';
import { isPopupCancellation } from './is-popup-cancellation';

export const GoogleLogin = () => {
  const provider = new GoogleAuthProvider();
  const addToast = useToastContext();

  provider.setCustomParameters({ prompt: 'select_account' });

  const handleClick = async () => {
    try {
      await signInWithPopup(auth, provider);
    } catch (e) {
      // Long delay in resolving the error promise is caused by
      // https://github.com/firebase/firebase-js-sdk/issues/8061#issuecomment-2047370693
      if (isPopupCancellation(e)) {
        return;
      }

      addToast({
        title: 'Error',
        content: () => `Something went wrong. Please contact us if the issue persists.`,
        kind: 'error',
      });
    }
  };

  return <GoogleButton title="Continue with Google" onClick={handleClick} />;
};
